// ----------------------------------------------------------------------

export function typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
        h6: {
          textTransform: 'uppercase',
          fontWeight: '800',
          color: theme.palette.primary.main,
          lineHeight: 1.2,
        },
      },
    },
  };
}
